<script setup>
import { ref, onMounted, computed } from "vue";
import { formatDate } from "@/utils/formatDate";
import { useStore } from "vuex";
import FloorProgressBar from "@/components/data/FloorProgressBar.vue";

const isLoading = ref(true);
const allBuildings = ref([]);
const building = ref({});
const currentIndex = ref(0);
const floor = ref([]);

const backgroundColors = [
  `linear-gradient(121deg, rgba(151, 73, 75,1) 4%, rgba(117, 56, 58,1) 33%, rgba(0, 24, 37,1) 100%)`,
  `linear-gradient(121deg, rgba(72,187,55,1) 4%, rgba(52,135,39,1) 33%, rgba(0,24,37,1) 100%)`,
  `linear-gradient(121deg, rgba(25,91,182,1) 4%, rgba(16,75,157,1) 33%, rgba(0,24,37,1) 100%)`,
  `linear-gradient(121deg, rgba(192,18,128,1) 4%, rgba(169,5,109,1) 33%, rgba(0,24,37,1) 100%)`,
  `linear-gradient(121deg, rgba(127,147,73,1) 4%, rgba(108,126,59,1) 33%, rgba(0,24,37,1) 100%)`,
];
const showNextBuilding = () => {
  currentIndex.value = (currentIndex.value + 1) % allBuildings.value.length;

  store.dispatch("appData/setCurrentSubLocationId", currentIndex.value);

  building.value = allBuildings.value[currentIndex.value];
  floor.value = building.value.SubItems;
};

const showPreviousBuilding = () => {
  currentIndex.value =
    (currentIndex.value - 1 + allBuildings.value.length) %
    allBuildings.value.length;

  store.dispatch("appData/setCurrentSubLocationId", currentIndex.value);

  building.value = allBuildings.value[currentIndex.value];
  floor.value = building.value.SubItems;
};

const props = defineProps({
  construction: {
    type: Object,
    required: true,
  },
});

const store = useStore();

let authToken = computed(() => store.getters["users/tokenUser"]);
let serverUrl = computed(() => store.getters["appData/getServerUrl"]);

let subLocationIndex = computed(
  () => store.getters["appData/getCurrentSubLocationId"],
);

const {
  MultiStatisticsServiceClient,
} = require("../../../proto-out/IMultiStatisticsService_grpc_web_pb");

const {
  ValueRequest_String,
} = require("../../../proto-out/IMultiStatisticsService_pb.js");

const fetchDataFromGrpc = async () => {
  try {
    const client = new MultiStatisticsServiceClient(serverUrl.value);
    const metadata = { Authorization: `Bearer ${authToken.value}` };

    const request = new ValueRequest_String();
    request.setValue(props.construction.actualinstance);

    const structuresExecutionTree = await new Promise((resolve, reject) => {
      client.getStructuresExecutionTree(request, metadata, (err, response) => {
        if (err) {
          console.error("gRPC Error:", err.message);
          reject(new Error("Failed to fetch data from gRPC"));
        } else {
          console.log("RESPONSE DATA ", response.toObject());
          resolve(response.toObject().valuesList[0].subitemsList);
        }
      });
    });

    allBuildings.value = structuresExecutionTree;

    building.value =
      structuresExecutionTree.find(
        (item) => item.id === subLocationIndex.value,
      ) || structuresExecutionTree[0];

    console.log(building.value);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchData = async () => {
  try {
    await fetchDataFromGrpc();
  } catch (err) {
    error.value = "Failed to load data: " + err.message;
    console.error(error.value);
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await fetchData();
});

const goToTimeTable = async (index) => {
  try {
    await store.dispatch("appData/setCurrentSubLocationId", index);
    await store.dispatch("clickedButton/updateClickedButton", "СРОКИ");
    await store.dispatch("currentIndex/updateCurrentIndex", 4);
  } catch (error) {
    console.error("Error occurred:", error);
  }
};

const goToQualityTable = async (index) => {
  try {
    await store.dispatch("appData/setCurrentSubLocationId", index);
    await store.dispatch("clickedButton/updateClickedButton", "КАЧЕСТВО");
    await store.dispatch("currentIndex/updateCurrentIndex", 3);
  } catch (error) {
    console.error("Error occurred:", error);
  }
};
</script>

<template>
  <v-row style="width: 60%; padding-bottom: 1em; margin: 0 auto">
    <img
      src="@/assets/icons/left_line.svg"
      @click="showPreviousBuilding"
      style="cursor: pointer"
    />
    <v-container class="custom-btn">
      <v-row class="align-center justify-space-between">
        <v-spacer></v-spacer>
        <v-col cols="6">
          <span class="label-text">
            {{ building.name }}
          </span>
        </v-col>
        <v-col cols="auto">
          <!-- TODO days -->
          <span style="font-size: 0.8vw">20 дн.</span>
          <img src="@/assets/icons/arrow.svg" style="height: 1vw" />
        </v-col>
      </v-row>
    </v-container>
    <img
      src="@/assets/icons/right_line.svg"
      @click="showNextBuilding"
      style="cursor: pointer"
    />
  </v-row>

  <v-container class="d-flex mb-3">
    <v-row align="center" class="ma-0">
      <MainFloorProgressBar
        title="ВРЕМЯ"
        :percents="building?.planpercentage"
        :size="0.8"
      />
    </v-row>
    <v-row align="center" class="ma-0">
      <MainFloorProgressBar
        title="СДАНО"
        :percents="building?.factpercentage"
        :size="0.8"
      />
    </v-row>
  </v-container>

  <v-container class="floors-wrapper">
    <v-row
      style="z-index: 0"
      v-for="(floorItem, index) in building?.subitemsList"
      :key="floorItem.id"
    >

      <v-card
        :class="{
          'first-card': index === 0,
          'last-card': index === building.subitemsList.length - 1,
        }"
        class="floor-card"
        width="100%"
        :style="{
          background: backgroundColors[index % backgroundColors.length],
        }"
      >
      <v-img src="../../../assets/bg/stairs.png" style="z-index: 10;" class="ma-0 pa-0" cover width="100%">
        <v-row class="d-flex">
          <v-col cols="2" class="border text-center pa-6">
            {{ floorItem.name }}
          </v-col>
          <v-col class="border" cols="4"></v-col>

          <!-- Floors progress bar section -->
          <v-col class="pa-12" cols="6">
            <v-row>
              <v-row dense align="center" class="ma-0">
                <FloorProgressBar
                  title="ВРЕМЯ"
                  :percents="floorItem.planpercentage"
                  :size="0.8"
                />
              </v-row>
              <v-col class="d-flex justify-space-between align-center">
                <div>
                  <v-icon size="35">mdi-clock-time-three-outline</v-icon>
                  <span> ВРЕМЯ </span>
                </div>
                <v-btn rounded="lg" class="mr-2">
                  <v-icon @click="goToTimeTable(floorItem.id)" size="35"
                    >mdi-menu-right</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-row align="center" class="ma-0">
                <FloorProgressBar
                  title="КАЧЕСТВО"
                  :percents="floorItem.factpercentage"
                  :size="0.8"
                />
              </v-row>
              <v-col class="d-flex justify-space-between align-center">
                <div>
                  <v-icon size="35">mdi-set-square </v-icon>
                  <span> КАЧЕСТВО </span>
                </div>
                <v-btn rounded="lg" class="mr-2">
                  <v-icon @click="goToQualityTable(floorItem.id)" size="35"
                    >mdi-menu-right</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-img>
      </v-card>
    </v-row>
  </v-container>
</template>

<style scoped>
.floors-wrapper {
  max-height: 60vh;
  overflow-y: auto;
  border-radius: 8px !important;
}

.floor-card :deep(.v-btn--size-default) {
  min-width: 40px !important;
  padding: 0 !important;
}

.floor-card {
  border-bottom: 1px solid white;
  border-radius: unset !important;
}

.first-card {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}
.last-card {
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
.border {
  border-right: 1px solid white !important;
}
.custom-btn {
  background-color: #00a3ff;
  color: white;
  padding: 0.6vw;
  border-radius: 10px;
  width: 90%;
}
.label-text {
  font-weight: bold;
  font-size: 0.9vw;
}
:deep(::-webkit-scrollbar-track) {
  margin: 0 !important;
}
</style>
